module.exports = __webpack_public_path__ + "media/images/flags/PF-bbe419b737e330ff30dedde0e2825581.svg";